import { connect } from 'react-redux'

import {
  getProfiles,
  setFilterValue
} from 'reduxpath/ducks/Profile/List'

import CountryFilter from './units'
import AddFilterProfile from 'utils/AddFilterProfile'

const mapStateToProps = (state) => ({
  selectionsCountry: state.Reference.selectionsCountry,
  profile: state.ProfileList,
  data: state.ProfileList.data,
  isLoading: state.ProfileList.isLoading,
})

const mapDispatchToProps = (dispatch) => ({
  setFilterValue(field, filter, sort) {
    return (e) => {
      let dataFilter = {
        ...filter 
      }
      dataFilter[field] = e.target.value

      const limit = 10
      const page = 1
      let qs = {
        sort: 'name ASC',
        limit,
        skip: (page - 1) * limit,
        value: dataFilter.profile,
        where: {},
      }

      qs = AddFilterProfile(qs, dataFilter, sort)

      dispatch(setFilterValue(dataFilter))
      dispatch(getProfiles(qs))
    }
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(CountryFilter)